import { Result, Button } from "antd"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { ErrorLayout } from "./ErrorLayout"

export const Error404: React.FC = () => {
  const { t } = useTranslation()
  return (
    <ErrorLayout>
      <Result
        status="404"
        title={t("pages.404.title")}
        subTitle={t("pages.404.subTitle")}
        extra={
          <Button size="large" type="primary">
            <Link to="/">{t("pages.404.link")}</Link>
          </Button>
        }
      />
    </ErrorLayout>
  )
}
